import { environment } from "@/config/environment";

export const rules = {
  required: (value) => (!!value && !!(value + "")?.length) || "This field is required.",
  min: (v) => v?.length >= 8 || "Min 8 characters",
  phoneNumber: (v) => !v?.length || environment.regex.phone.test(v) || "Phone number is invalid",
  email: (v) => !v?.length || !!environment.regex.email.test(v) || "Email is invalid",
  number: (v) => !v?.length || /^[0-9]*$/.test(v) || "Invalid number",
  password: (v) => !!environment.regex.passwordNormal.test(v) || "Password is too short",
  url: (v) => !v?.length || environment.regex.url.test(v) || "This URL is invalid",
  domain: (v) => !v?.length || environment.regex.domain.test(v) || "This domain is invalid",
  subDomain: (v) => !v?.length || environment.regex.subDomain.test(v) || "This sub-domain is invalid",
};
